import React, { useEffect, useState } from "react";
import CustomLoader from "../components/CustomLoader";
import axios from "axios";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { getApi, putFormDataApi } from "../config/configAxios";
import JoditEditor from "jodit-react";
import { config } from "../utils/JoditConfig";
import AdminLayout from "../layouts/adminLayout/AdminLayout";

const About = () => {
  const [data, setData] = useState({});
  const [oldFile, setOldFile] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchData = async () => {
    try {
      const res = await getApi("about");
      setData(res.data);
      setOldFile(res.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setData((prevData) => ({ ...prevData, file: file }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("id", oldFile.id);
    formData.append("title_en", data.title_en);
    formData.append("title_bn", data.title_bn);
    formData.append("content_en", data.content_en);
    formData.append("file", data.file);
    formData.append("content_bn", data.content_bn);
    formData.append("yt", data.yt);
    formData.append("fb", data.fb);
    formData.append("twi", data.twi);
    try {
      await putFormDataApi("about", formData);

      fetchData();
      toast.success("Data updated successfully!");
    } catch (err) {
      toast.error(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          "update failed"
      );
      console.log(err)
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout title={"About"}>
      {loading ? (
        <CustomLoader />
      ) : (
        <form className="" onSubmit={handleUpdate}>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
            <div>
              <label htmlFor="title_en" className="font-semibold text-sm">
                Title EN
              </label>
              <input
                type="text"
                id="title_en"
                name="title_en"
                value={data?.title_en}
                onChange={handleInputChange}
                placeholder="title_en"
                className="form-control"
                required
              />
            </div>
            <div>
              <label htmlFor="title_bn" className="font-semibold text-sm">
                Title BN
              </label>
              <input
                type="text"
                id="title_bn"
                name="title_bn"
                value={data?.title_bn}
                onChange={handleInputChange}
                placeholder="title_bn"
                className="form-control"
                required
              />
            </div>

            <div>
              <label htmlFor="file" className="font-semibold text-sm">
                Image
              </label>
              <input
                type="file"
                id="file"
                name="file"
                onChange={handleFileChange}
                placeholder="Charger votre fichier"
                className="form-control"
              />
            </div>
            <div className="flex gap-2">
              <div>
                <label htmlFor="file" className="font-semibold text-sm">
                  Image
                </label>
                <img
                  className="h-20 border border-dashed rounded-md p-3"
                  src={`${process.env.REACT_APP_API_FILE_URL}${oldFile?.file}`}
                  alt=""
                />
              </div>
              <div>
                {data?.file && typeof data?.file !== "string" && (
                  <>
                    <label htmlFor="file" className="font-semibold text-sm">
                      New image
                    </label>
                    <img
                      className="h-20 border border-dashed rounded-md p-3"
                      src={URL.createObjectURL(data?.file)}
                      alt="Preview"
                    />
                  </>
                )}
              </div>
            </div>

            <div>
              <label htmlFor="fb" className="font-semibold text-sm">
                Facebook
              </label>
              <input
                type="text"
                id="fb"
                name="fb"
                onChange={handleInputChange}
                value={data?.fb}
                placeholder="facebook link"
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="yt" className="font-semibold text-sm">
                Youtube
              </label>
              <input
                type="text"
                id="yt"
                name="yt"
                value={data?.yt}
                onChange={handleInputChange}
                placeholder="Youtube link"
                className="form-control"
              />
            </div>
            <div>
              <label htmlFor="twi" className="font-semibold text-sm">
                Twitter
              </label>
              <input
                type="text"
                id="twi"
                name="twi"
                value={data?.twi}
                onChange={handleInputChange}
                placeholder="Twitter link"
                className="form-control"
              />
            </div>

            <div className="md:col-span-2">
              <label htmlFor="content_en" className="font-semibold text-sm">
                About EN
              </label>
              <JoditEditor
                config={config}
                tabIndex={1}
                value={data?.content_en}
                onBlur={(newContent) =>
                  setData((prevData) => ({
                    ...prevData,
                    content_en: newContent,
                  }))
                }
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="content_bn" className="font-semibold text-sm">
                About BN
              </label>
              <JoditEditor
                config={config}
                tabIndex={1}
                value={data?.content_bn}
                onBlur={(newContent) =>
                  setData((prevData) => ({
                    ...prevData,
                    content_bn: newContent,
                  }))
                }
              />
            </div>

            <div className="md:col-span-2">
              <button
                disabled={isSubmitting}
                type="submit"
                className="btn-green w-full"
                data-ripple-light="true"
              >
                {isSubmitting ? <BeatLoader color="#fff" /> : "Update"}
              </button>
            </div>
          </div>
        </form>
      )}
    </AdminLayout>
  );
};

export default About;
